import React,{useState} from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import CtData from './CtData';
import CtAlarmas from './CtAlarmas';
import { useParams } from 'react-router-dom';
import './VerCt.css';
import { BsArrowRightCircle, BsArrowLeftCircle } from 'react-icons/bs';

function VerCt(){
    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    const params = useParams();
    const { ct } = params;

    const [nombreCT,setNombreCT] = useState();
    const childToParent = (nombreCT) => {
        setNombreCT(nombreCT)
    }

    if(code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }
    
    //*************************CAMBIAR CT CON LAS FLECHAS*************************************
    var numberCT = (JSON.parse(sessionStorage.getItem("CTConfiguration"))).length;
    function handleClickChangeLeft(){
        if(parseInt(ct) === 1){
            window.location = '/#/ct/' + numberCT;
        }else{
            window.location ='/#/ct/' + (parseInt(ct) - parseInt(1));
        }
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }

    function handleClickChangeRight(){
        if(parseInt(ct) === numberCT){
            window.location = '/#/ct/1';
        }else{
            window.location ='/#/ct/' + (parseInt(ct) + parseInt(1));
        }
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }
    window.addEventListener("orientationchange", function(){
        window.location.reload();
      });
    return (
        <div className='div-tabs-ct'>
            <div className='div-ct-title'>
                <div className='div-arrow-icon-ct'><BsArrowLeftCircle size={30} className='arrow-icon-ct' onClick={() => {handleClickChangeLeft()}}/></div>
                <div style={{position: 'relative', float: 'left'}}><h3>{nombreCT}</h3></div>
                <div className='div-arrow-icon-ct'><BsArrowRightCircle size={30} className='arrow-icon-ct' onClick={() => {handleClickChangeRight()}}/></div>
            </div>
            <div className='div-ct-tabs' style={{overflow: 'auto'}}>
                <Tabs defaultActiveKey="general">
                    <Tab eventKey="general" title="General">
                        <CtData childToParent={childToParent} code={code} ct={ct}/>
                    </Tab>
                    <Tab eventKey="alarmas" title="Alarmas">
                        <CtAlarmas code={code} ct={ct}/>
                    </Tab>
                </Tabs>
            </div>
        </div>
    );
};

export default VerCt;